export default __webpack_public_path__ + "static/media/Action_join.49987e25.wav";